<template>
  <el-dialog
    title="商品校验"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="1000px"
    class="spareGetAddNew-errorTip-dialog"
  >
    <p>下单商品数量不满足起订和步长限制，请修改商品数量。</p>
    <p>客户名称：{{ companyName }}</p>
    <el-table border :data="dataList" height="600">
      <el-table-column
        header-align="center"
        align="center"
        prop="oldGoodsCode"
        label="客户商品编码"
        width="120"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="goodsCode"
        label="商品编码"
        width="120"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="goodsName"
        label="商品名称"
        width="160"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="goodsNum"
        label="数量"
        width="80"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="fileName"
        label="类目"
        width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.categoryName1 }} | {{ scope.row.categoryName2 }} |
          {{ scope.row.categoryName3 }}
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="remark"
        label="备注"
      >
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataList: [],
      companyName: "",
    };
  },
  methods: {
    onShow(list, companyName) {
      this.companyName = companyName;
      this.dataList = list;
      this.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
<style lang="scss">
.spareGetAddNew-errorTip-dialog {
  .el-dialog__body {
    padding: 10px 20px;
  }
}
</style>
